import ApiCaller from "./helper/ApiCaller";
import serviceResponseValidation from "./validation/serviceResponseValidation";
import config from '../config';

export default async slug => {

    try {
        const response = await fetchJSON(slug);
        const data = await responseValidation(response);

        return {
            data,
            hasError: false,
            errorMessage: null,
        };
    } catch (error) {
        return Promise.reject({
            data: null,
            hasError: true,
            errorMessage: error,
        });
    }
};

const fetchJSON = filter => {
    const options = {
        headers: {
            accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    };

    return ApiCaller(options).get(
        `${config.apiUrl}api/Venue/MenuJson?slug=${filter}`,
    );
};

const responseValidation = response => {
    return serviceResponseValidation(response);
}